import React, { useState } from "react";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import { ArticleDataTable } from "./Layout";
import RawScoresActions from "./RawScoresActions";
import RawScoresRow from "./RawScoresRow";
import { downloadCsvUrl } from "./Url";

const generateTableMatrix = (allDates, modeldata) => {
  const matrix = [];
  if (allDates === undefined) {
    return matrix;
  }
  allDates.sort((a,b) => new Date(b) - new Date(a)).forEach(ad => {
    const scoreValues = modeldata.map(m => {
      const { id } = m;
      const val = m.datapoints
        .filter(p => p.score_date === ad)
        .map(p => p.score_value);
      return {
        model_id: id,
        score_value: val[0]
      };
    });

    const row = {
      scoreDate: ad,
      modelScores: scoreValues
    };

    matrix.push(row);
  });
  return matrix;
};

const RawScores = props => {
  /* set state */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  /* extract props */
  const {
    geo,
    allDates,
    modeldata,
  } = props;

  const totalCount = allDates !== undefined ? allDates.length : 0;

  const handleChangePage = pageNumber => {
    setPage(pageNumber);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  return (
    <ArticleDataTable
      header="Data Table"
      headerControls={(<Button
        href={downloadCsvUrl(geo)}
        variant="outlined"
        download
      >
        Export to CSV
      </Button>)}
    >
      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              {modeldata.map(m => (
                <TableCell key={m.id}>{m.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {generateTableMatrix(allDates, modeldata)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <RawScoresRow
                  key={row.scoreDate}
                  modelScores={row.modelScores}
                  scoreDate={row.scoreDate}
                />
              ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={2}
                count={totalCount}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                ActionsComponent={RawScoresActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Grid>
    </ArticleDataTable>
  );
};

export default RawScores;
